import React from 'react'

export default function CourseLocation(props) {
  return (
    <>
    <span>{props.location}</span>
    </>
  )
}
